<template>
  
  <div class="homeIndexF">
    <div class="homeIndex">
      <HomeHeader></HomeHeader>
      <div id="home" :style="{ height: innerHeight }">
        <div class="flex-center">
          <div class="content">
            <div class="nav">
              <ul class="first-nav">
                <li>
                  <div
                    @click="jumpPage('eios/companyInfo', '系统设置')"
                    class="medium-nav control-panel"
                    :class="menuList.includes('系统设置') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('系统设置')"
                      src="../../assets/images/home/control-panel.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/control-panel-disabled.png"
                      alt=""
                    />
                    <span class="medium-text">系统设置</span>
                  </div>
                </li>
                <li class="flex-horizontal-between">
                  <div
                    class="mini-nav operation"
                    @click="
                      jumpPage('operationManagement/inspectionTask', '运维管理')
                    "
                    :class="menuList.includes('运维管理') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('运维管理')"
                      src="../../assets/images/home/operation.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/operation-disabled.png"
                      alt=""
                    />
                    <span class="mini-text">运维管理</span>
                  </div>
                  <div
                    class="mini-nav examine"
                    @click="Jump('Management', '考核管理')"
                    :class="menuList.includes('考核管理') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('考核管理')"
                      src="../../assets/images/home/examine.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/examine-disabled.png"
                      alt=""
                    />
                    <span class="mini-text">考核管理</span>
                  </div>
                </li>
                <li>
                  <div
                    class="medium-nav device"
                    @click="Jump('Administration', '资产管理')"
                    :class="menuList.includes('资产管理') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('资产管理')"
                      src="../../assets/images/home/device.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/device-disabled.png"
                      alt=""
                    />
                    <span class="medium-text">资产管理</span>
                  </div>
                </li>
                <li class="flex-horizontal-between">
                  <div
                    class="mini-nav aily-work"
                    @click="Jump('Document', '日常办公')"
                    :class="menuList.includes('日常办公') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('日常办公')"
                      src="../../assets/images/home/daily-work.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/daily-work-disabled.png"
                      alt=""
                    />
                    <span class="mini-text">日常办公</span>
                  </div>
                  <div
                    class="mini-nav knowledge"
                    @click="Jump('Library', '知识库')"
                    :class="menuList.includes('知识库') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('知识库')"
                      src="../../assets/images/home/knowledge.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/knowledge-disabled.png"
                      alt=""
                    />
                    <span class="mini-text" style="left: 0.38rem">知识库</span>
                  </div>
                </li>
              </ul>
              <ul class="second-nav">
                <li>
                  <div
                    class="big-nav monitor"
                    @click="jumpPage('monitoringLeft', '综合监控')"
                    :class="menuList.includes('综合监控') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('综合监控')"
                      src="../../assets/images/home/monitor.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/monitor-disabled.png"
                      alt=""
                    />
                    <span class="big-text">综合监控</span>
                  </div>
                </li>
                <li class="flex-horizontal-between">
                  <div
                    class="mini-nav secure"
                    @click="Jump('Control', '安全管理')"
                    :class="menuList.includes('安全管理') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('安全管理')"
                      src="../../assets/images/home/secure.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/secure-disabled.png"
                      alt=""
                    />
                    <span class="mini-text">安全管理</span>
                  </div>
                  <div
                    class="mini-nav energy"
                    @click="Jump('Equipment', '能源管理')"
                    :class="menuList.includes('能源管理') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('能源管理')"
                      src="../../assets/images/home/energy.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/energy-disabled.png"
                      alt=""
                    />
                    <span class="mini-text">能源管理</span>
                  </div>
                </li>
                <li class="flex-horizontal-between">
                  <div
                    class="mini-nav analysis"
                    @click="Jump('StatisticsAnalysis', '统计分析')"
                    :class="menuList.includes('统计分析') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('统计分析')"
                      src="../../assets/images/home/analysis.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/analysis-disabled.png"
                      alt=""
                    />
                    <span class="mini-text">统计分析</span>
                  </div>
                  <div
                    class="mini-nav plan"
                    @click="Jump('inspectionPlan', '计划管理')"
                    :class="menuList.includes('计划管理') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('计划管理')"
                      src="../../assets/images/home/plan.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/plan-disabled.png"
                      alt=""
                    />
                    <span class="mini-text">计划管理</span>
                  </div>
                </li>
              </ul>
              <ul class="ai-forecast-nav">
                <li
                  v-for="item in aiForecastModules"
                  :key="item.key"
                  @click="openAiForecast(item)"
                >
                  <div class="ai-forecast-card" :class="item.key">
                    <span class="ai-mark">AI</span>
                    <p>{{ item.title }}</p>
                    <em>{{ item.desc }}</em>
                  </div>
                </li>
              </ul>
              <ul class="third-nav">
                <li>
                  <div
                    class="small-nav electricity"
                    @click="jumpPage('ywhc/source', '源侧发电')"
                    :class="menuList.includes('源侧发电') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('源侧发电')"
                      src="../../assets/images/home/electricity.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/electricity-disabled.png"
                      alt=""
                    />
                    <span style="color: #3bebbc" class="small-text"
                      >源侧发电</span
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="small-nav water"
                    @click="jumpPage('electricityHome', '网侧配电')"
                    :class="menuList.includes('网侧配电') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('网侧配电')"
                      src="../../assets/images/home/water.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/water-disabled.png"
                      alt=""
                    />
                    <span style="color: #4c93fd" class="small-text"
                      >网侧配电</span
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="small-nav gas"
                    @click="jumpPage('ywhc/load', '荷侧负荷')"
                    :class="menuList.includes('荷侧负荷') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('荷侧负荷')"
                      src="../../assets/images/home/gas.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/gas-disabled.png"
                      alt=""
                    />
                    <span style="color: #fbd072" class="small-text"
                      >荷侧负荷</span
                    >
                  </div>
                </li>
                <li>
                  <div
                    class="small-nav heating"
                    @click="jumpPage('ywhc/storage', '储侧储能')"
                    :class="menuList.includes('储侧储能') ? '' : 'disabled'"
                  >
                    <img
                      v-if="menuList.includes('储侧储能')"
                      src="../../assets/images/home/heating.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/images/home/heating-disabled.png"
                      alt=""
                    />
                    <span style="color: #eb4646;" class="small-text">
                      储侧储能
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="chart">
              <div style="margin-bottom: 22px" class="electricity-chart">
                <span class="chart-title">源网荷储运行趋势统计</span>
                <div class="energy-operate">
                  <div class="all-energy">
                    <div
                      v-for="(item, index) in chartData"
                      :key="index"
                      @click="switchType(index)"
                    >
                      <span
                        :class="index === 0 ? 'selected' : 'disabled'"
                        class="energy-type"
                        >{{ item }}</span
                      >
                    </div>
                  </div>
                </div>
                <div id="energy"></div>
              </div>
              <div class="carbon-chart">
                <span class="chart-title">碳排情况统计</span>
                <div class="carbon-operate">
                  <ul>
                    <li class="consume">
                      <img src="../../assets/images/home/CO2.png" alt="" />
                      <div>
                        <p>{{totalCo2}}</p>
                        <span>二氧化碳排放量</span>
                      </div>
                    </li>
                    <li class="consume" style="margin-right: 0;">
                      <img src="../../assets/images/home/fell.png" alt="" />
                      <div>
                        <p class="tree">{{equivalentTreePlanting}}</p>
                        <span>等效植树</span>
                      </div>
                    </li>
                    <!-- <li style="margin-right: 0" class="consume">
                      <img src="../../assets/images/home/burn.png" alt="" />
                      <div>
                        <p>0</p>
                        <span>燃烧标准煤</span>
                      </div>
                    </li> -->
                  </ul>
                </div>
                <div id="carbon"></div>
              </div>
            </div>
          </div>
          <div class="mascot">
            <img src="../../assets/images/home/mascot.png" alt="" />
          </div>
        </div>
      </div>
      <HomeFooter></HomeFooter>
    </div>
  </div>
</template>
<script>
import HomeHeader from "../../components/homeHeader.vue";
import HomeFooter from "../../components/footer.vue";
import { monitorApi } from "@/api/monitor.js";
import { isDemoMode } from "@/utils/demoMode";
import * as echarts from "echarts";
export default {
  components: { HomeHeader, HomeFooter },
  data() {
    return {
      chartData: ["源", "网", "荷", "储"],
      selectType: 0,
      innerHeight: "",
      menuList: [],
      aiForecastModules: [
        { key: "source-trade", title: "源侧交易预测", desc: "发电量 / 绿电收益" },
        { key: "grid-trade", title: "网侧交易预测", desc: "购电计划 / 电价研判" },
        { key: "load-trade", title: "荷侧交易预测", desc: "负荷预测 / 需求响应" },
        { key: "storage-trade", title: "储侧交易预测", desc: "充放电 / 套利策略" },
      ],
      totalCo2:'',
      equivalentTreePlanting:''
    };
  },
  created() {
    this.$store.commit("increment", "首页");
    this.$store.commit("selectChild", "");
    this.$store.commit("selectChildren", "");
  },
  mounted() {
    this.queryTotalCarbon();
    this.queryTotalElectricity();
    // this.getsso()
    // sessionStorage.setItem('first_menu','首页')
    let innerHeight = window.innerHeight - 121;
    this.innerHeight = `${innerHeight}px`;
    
    // 修改权限检查逻辑，开发环境下给予所有权限
    if (isDemoMode) {
      // 开发环境下显示所有菜单
      this.menuList = [
        "系统设置", "运维管理", "考核管理", "资产管理", 
        "日常办公", "知识库", "综合监控", "安全管理", 
        "能源管理", "统计分析", "计划管理", 
        "驾驶舱-电", "驾驶舱-水", "驾驶舱-气", "驾驶舱-暖",
        "源侧发电", "网侧配电", "荷侧负荷", "储侧储能"
      ];
    } else {
      // 生产环境使用真实权限
      this.menuList = this.$store.state.menuList.map((item) => {
        if(!item.hidden){
          return item.meta.title;
        }
      });
    }
    const menuAliasMap = {
      "驾驶舱-电": "源侧发电",
      "驾驶舱-水": "网侧配电",
      "驾驶舱-气": "荷侧负荷",
      "驾驶舱-暖": "储侧储能",
      "源侧发电": "驾驶舱-电",
      "网侧配电": "驾驶舱-水",
      "荷侧负荷": "驾驶舱-气",
      "储侧储能": "驾驶舱-暖",
    };
    this.menuList = Array.from(new Set(this.menuList.flatMap((item) => {
      return item ? [item, menuAliasMap[item]].filter(Boolean) : [];
    })));
    console.log("~~~~``", this.menuList);
  },

  methods: {
    getsso(){
      let params = {
        userName:JSON.parse(sessionStorage.getItem('user_info')).userName
      }
      monitorApi.sso(params).then(res => {
        
      })
    },
    Jump(el, name) {
      // 开发环境下跳过权限检查
      if (isDemoMode || this.menuList.includes(name)) {
        // sessionStorage.setItem('first_menu',name)
        this.$store.commit("increment", name);
        this.$router.push({
          name: el,
        });
      } else {
        this.$message({
          message: "您没有查看该菜单的权限",
          type: "warning",
          duration: 3000,
          customClass: "messageText",
        });
      }
    },
    switchType(index) {
      // this.selectType = index;
    },
    openAiForecast(item) {
      this.$message({
        message: `${item.title}为占位模块，后续接入人工智能预测模型和交易策略接口。`,
        type: "info",
        duration: 2400,
        customClass: "messageText",
      });
    },
    jumpPage(path, name) {
      if (name === "Eios控制面板") {
        sessionStorage.setItem("componentStatus", 0);
        this.$store.commit("updateStatus", 0);
      } else if (name === "驾驶舱-电" || name === "源侧发电") {
        sessionStorage.setItem("componentStatus", 1);
        this.$store.commit("updateStatus", 1);
      }
      
      // 开发环境下跳过权限检查
      if (isDemoMode || this.menuList.includes(name)) {
        // sessionStorage.setItem('first_menu',name)
        this.$store.commit("increment", name);
        this.$router.push(`/${path}`);
      } else {
        this.$message({
          message: "您没有查看该菜单的权限",
          type: "warning",
          duration: 3000,
          customClass: "messageText",
        });
      }
    },
    // 1.总用电量情况统计
    queryTotalElectricity() {
      // 开发环境下使用模拟数据
      if (isDemoMode) {
        // 模拟数据
        const mockData = [{
          "h0": 1200,
          "h1": 1100,
          "h2": 1000,
          "h3": 900,
          "h4": 800,
          "h5": 1000,
          "h6": 1500,
          "h7": 2000,
          "h8": 2500,
          "h9": 3000,
          "h10": 3200,
          "h11": 3100,
          "h12": 3300,
          "h13": 3400,
          "h14": 3200,
          "h15": 3000,
          "h16": 2800,
          "h17": 3100,
          "h18": 3500,
          "h19": 3300,
          "h20": 3000,
          "h21": 2500,
          "h22": 2000,
          "h23": 1500
        }];
        let object = mockData[0];
        let xAxisData = [];
        let seriesData = [];
        for (const key in object) {
          let time = Number(key.slice(1));
          xAxisData.push(`${time}点`);
          if (object[key]) {
            seriesData.push(object[key]);
          } else {
            seriesData.push(`0`);
          }
        }
        this.$nextTick(() => {
          this.drawEnergy(xAxisData, seriesData);
        });
        return;
      }
      
      monitorApi.queryTotalElectricity().then((res) => {
        let object = res[0];
        let xAxisData = [];
        let seriesData = [];
        for (const key in object) {
          let time = Number(key.slice(10,13));
          xAxisData.push(`${time}点`);
          if (object[key]) {
            seriesData.push(object[key]);
          } else {
            seriesData.push(`0`);
          }
        }
        this.drawEnergy(xAxisData, seriesData);
      });
    },
     // 2.碳排情况统计
     queryTotalCarbon() {
      // 开发环境下使用模拟数据
      if (isDemoMode) {
        // 模拟数据
        const mockData = {
          code: 200,
          data: {
            totalCo2: 123.456,
            equivalentTreePlanting: 789.012,
            powerList: [
              {ts: "h0", tanPait: 10.5},
              {ts: "h1", tanPait: 9.8},
              {ts: "h2", tanPait: 8.2},
              {ts: "h3", tanPait: 7.1},
              {ts: "h4", tanPait: 6.3},
              {ts: "h5", tanPait: 7.2},
              {ts: "h6", tanPait: 9.5},
              {ts: "h7", tanPait: 15.3},
              {ts: "h8", tanPait: 22.1},
              {ts: "h9", tanPait: 28.7},
              {ts: "h10", tanPait: 32.4},
              {ts: "h11", tanPait: 35.2},
              {ts: "h12", tanPait: 36.8},
              {ts: "h13", tanPait: 37.1},
              {ts: "h14", tanPait: 36.2},
              {ts: "h15", tanPait: 34.7},
              {ts: "h16", tanPait: 32.1},
              {ts: "h17", tanPait: 36.5},
              {ts: "h18", tanPait: 39.2},
              {ts: "h19", tanPait: 37.8},
              {ts: "h20", tanPait: 34.1},
              {ts: "h21", tanPait: 28.6},
              {ts: "h22", tanPait: 22.3},
              {ts: "h23", tanPait: 16.7}
            ]
          }
        };
        
        this.totalCo2 = mockData.data.totalCo2.toFixed(3);
        this.equivalentTreePlanting = mockData.data.equivalentTreePlanting.toFixed(3);
        let xAxisData = [];
        let seriesData = [];
        mockData.data.powerList.forEach(element => {
          xAxisData.push(Number(element.ts.slice(1)) + '点');
          seriesData.push(element.tanPait.toFixed(3));
        });
        this.$nextTick(() => {
          this.drawCarbon(xAxisData, seriesData);
        });
        return;
      }
      
      monitorApi.queryTotalCarbon().then((res) => {
        if(res.code===200){
         this.totalCo2=res.data.totalCo2.toFixed(3)
         this.equivalentTreePlanting=res.data.equivalentTreePlanting.toFixed(3)
         let xAxisData = [];
         let seriesData = [];
         res.data.powerList.forEach(element => {
          xAxisData.push(Number(element.ts.slice(10,13)) + '点')
          seriesData.push(element.tanPait.toFixed(3))
         });
        this.drawCarbon(xAxisData, seriesData);
        }
      });
    },
    drawEnergy(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        legend: {
          icon: "circle",
          right: "8%",
          top: "10%",
          textStyle: {
            color: "#AED6FF",
          },
        },
        grid: {
          left: 90,
          right: 60,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            width: 24,
            interval: 0,
            textStyle: {
              color: "#AED6FF", // 设置字体颜色
              fontSize: 12,
            },
          },
          axisTick: {
            show: false, // 取消刻度线显示
          },
        },
        yAxis: {
          name: "运行功率:kW",
          nameTextStyle: {
            color: "rgb(167, 206, 247)",
          },
          // data: [0,1000,2000,3000,4000,5000,6000],
          axisLabel: {
            textStyle: {
              color: "#AED6FF", // 设置字体颜色
              fontSize: 12,
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#A0C6EF",
            },
          },
        },
        series: [
          {
            name: "源网荷储趋势",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#1ACD9E" },
                { offset: 1, color: "#45F3C6" },
              ]),
              barBorderRadius:[30,30,0,0] ,
            },
            data: seriesData,
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.$nextTick(() => {
        echarts.init(document.getElementById("energy")).setOption(option);
      });
    },
    drawCarbon(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        grid: {
          left: 90,
          right: 60,
        },
        legend: {
          icon: "circle",
          right: "8%",
          right: "8%",
          top: "10%",
          textStyle: {
            color: "#AED6FF",
          },
        },
        xAxis: {
          data:xAxisData,
          axisLabel: {
            interval: 0,
            width: 24,
            textStyle: {
              color: "#AED6FF", // 设置字体颜色
              fontSize: 12,
            },
          },
          axisTick: {
            show: false, // 取消刻度线显示
          },
        },
        yAxis: {
          name: "碳排:kt",
          nameTextStyle: {
            color: "rgb(167, 206, 247)",
          },

          // data: [0, 1, 2, 3, 4, 5, 6],
          axisLabel: {
            textStyle: {
              color: "#AED6FF", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
            // lineStyle:{
            //   type:'dashed',
            //   color: '#A0C6EF'
            // }
          },
        },
        series: [
          {
            name: "总碳排",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#1049A9" },
                { offset: 1, color: "#4E96D7" },
              ]),
              barBorderRadius:[30,30,0,0] ,
            },
            data: seriesData,
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.$nextTick(() => {
        echarts.init(document.getElementById("carbon")).setOption(option);
      });
    },
  },
};
</script>
<style scoped>
#home {
  width: 100%;
  /* height: calc(100vh-121px); */
  min-width: 10.2rem;
  background: url(../../assets/images/home/background.jpg) no-repeat center;
  background-size: cover;
  font-size: 16px;
  position: relative;
}

.content {
  display: flex;
  justify-content: center;
}

.flex-center {
  height: calc(100vh - 130px);
  /* min-width: 100%; */
  /* overflow: auto; */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity .18s ease;
}

.nav {
  display: flex;
}

.nav ul {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-right: 0.1rem;
  /* margin-right: 8px; */
}

.nav ul:last-child {
  margin-right: 0.4rem;
  /* margin-right: 8px; */
}

.nav ul li {
  margin-bottom: 0.09rem;
  cursor: pointer;
}

.nav ul li:last-child {
  margin-bottom: 0;
}

/* 中等导航 */
.medium-nav {
  width: 2.69rem;
  height: 1.28rem;
  position: relative;
}

.medium-nav img {
  width: 2.69rem;
  height: 1.28rem;
}

.medium-text {
  position: absolute;
  left: 0.34rem;
  top: 0.56rem;
  font-size: 0.18rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #aed6ff;
}

/* mini导航 */
.mini-nav {
  width: 1.31rem;
  height: 1.28rem;
  position: relative;
}

.mini-nav img {
  width: 1.31rem;
  height: 1.28rem;
}

.mini-text {
  position: absolute;
  left: 0.28rem;
  bottom: 0.28rem;
  font-size: 0.18rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #aed6ff;
}

/* 小型导航 */
.small-nav {
  width: 2.67rem;
  height: 1.28rem;
  position: relative;
}

.small-nav img {
  width: 2.67rem;
  height: 1.28rem;
}

.small-text {
  position: absolute;
  left: 1.14rem;
  bottom: 0.53rem;
  font-size: 0.2rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

/* 超大导航 */
.big-nav {
  width: 2.7rem;
  height: 2.64rem;
  position: relative;
}

.big-nav img {
  width: 2.7rem;
  height: 2.64rem;
}

.big-text {
  position: absolute;
  left: 0.99rem;
  bottom: 0.72rem;
  font-size: 0.18rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #aed6ff;
}

/* disabled */
.disabled {
  cursor: not-allowed !important;
}

.first-nav {
  width: 2.69rem;
}

.ai-forecast-nav {
  width: 2.16rem;
}

.ai-forecast-nav li {
  margin-bottom: 0.09rem;
}

.ai-forecast-card {
  width: 2.16rem;
  height: 1.28rem;
  position: relative;
  box-sizing: border-box;
  padding: 0.22rem 0.18rem 0;
  background:
    radial-gradient(circle at 88% 18%, rgba(64, 236, 194, 0.2), transparent 34%),
    linear-gradient(180deg, rgba(24, 82, 173, 0.42), rgba(5, 24, 76, 0.76));
  border: 1px solid rgba(80, 137, 235, 0.35);
  box-shadow: inset 0 0 0.22rem rgba(47, 141, 255, 0.16);
  overflow: hidden;
}

.ai-forecast-card::before {
  content: "";
  position: absolute;
  left: 0.14rem;
  right: 0.14rem;
  bottom: 0.12rem;
  height: 1px;
  background: linear-gradient(90deg, rgba(64, 236, 194, 0.8), transparent);
}

.ai-forecast-card .ai-mark {
  display: inline-block;
  width: 0.42rem;
  height: 0.24rem;
  line-height: 0.24rem;
  text-align: center;
  color: #041c4c;
  background: #40ecc2;
  font-size: 0.14rem;
  font-weight: 700;
}

.ai-forecast-card p {
  margin: 0.12rem 0 0;
  color: #e8f4ff;
  font-size: 0.18rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

.ai-forecast-card em {
  display: block;
  margin-top: 0.08rem;
  color: #8ebeff;
  font-size: 0.12rem;
  font-family: Microsoft YaHei;
  font-style: normal;
}

.ai-forecast-card.source-trade .ai-mark {
  background: #40ecc2;
}

.ai-forecast-card.grid-trade .ai-mark {
  background: #52a2ff;
}

.ai-forecast-card.load-trade .ai-mark {
  background: #f6cd29;
}

.ai-forecast-card.storage-trade .ai-mark {
  background: #ff8c56;
}

.flex-horizontal-between {
  display: flex;
  justify-content: space-between;
}

/* 图标 */
.electricity-chart,
.carbon-chart {
  width: 6.78rem;
  height: 2.53rem;
  background: url(../../assets/images/home/chart-background.png) no-repeat
    center;
  background-size: cover;
  position: relative;
}

.chart-title {
  font-size: 0.16rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #aed6ff;
  position: absolute;
  left: 0.75rem;
  top: 0.11rem;
}

.energy-operate {
  position: absolute;
  right: 0.33rem;
  top: 0.28rem;
  z-index: 100;
}

.all-energy {
  display: flex;
}

.all-energy .energy-type {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 0.02rem;
  display: inline-block;
  font-size: 0.12rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #aed6ff;
  text-align: center;
  line-height: 0.25rem;
  cursor: pointer;
}

.selected {
  background: #1852ad;
}

.disabled {
  cursor: not-allowed;
}

.carbon-operate {
  position: absolute;
  top: 0.15rem;
  right: 0.37rem;
}

.carbon-operate ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
}

.consume {
  margin-right: 0.18rem;
  display: flex;
}

.consume div {
  height: 0.38rem;
  margin-left: 0.06rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.consume p {
  font-size: 0.2rem;
  font-family: DIN Next LT Pro;
  font-weight: 400;
  color: #166ebf;
  margin: 0;
}

.consume img {
  width: 0.37rem;
  height: 0.38rem;
}

.consume p::after {
  content: "(吨)";
  font-size: 0.12rem;
  font-family: Microsoft YaHei;
  margin-left: 5px;
}

.consume .tree::after {
  content: "(棵)";
}

.consume span {
  font-size: 0.12rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #bccaf3;
}

#energy,
#carbon {
  width: 7.6rem;
  height: 2.5rem;
  position: absolute;
  bottom: -0.3rem;
  left: -0.3rem;
}

.mascot {
  position: absolute;
  right: 0.79rem;
  bottom: 1rem;
}

.nav ul img {
  transition: transform 0.2s ease-in-out;
  transform: translateZ(0);
}

/* .control-panel:hover img,
.operation:hover img,
.examine:hover img,
.examine:hover img,
.aily-work:hover img,
.knowledge:hover img,
.monitor:hover img,
.secure:hover img,
.energy:hover img,
.analysis:hover img,
.plan:hover img,
.electricity:hover img,
.water:hover img,
.gas:hover img,
.heating:hover img {
  transform: scale(1.1);
  transition: transform 0.2s ease-in-out;
} */
.nav ul li div:not(.disabled):hover img {
  transform: scale(1.1);
  transition: transform 0.1s ease-in-out;
}

.homeIndex {
  width: 100%;
  min-width: 1920px;
  /* height: 100vh; */
}

.homeIndexF {
  width: 100%;
  overflow: auto;
}
</style>
